import React from "react";

/**
 * Error Boundary global. Captura errores de React (DOM mutations de extensiones,
 * runtime errors) y muestra fallback amigable en vez de pantalla blanca.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || "Error inesperado";
    const isExtensionError = /removeChild|insertBefore|appendChild|Failed to execute/i.test(msg);

    return (
      <div className="min-h-screen bg-[#F4F4F0] flex items-center justify-center p-6">
        <div className="bg-white border border-[#0A0A0A] max-w-lg w-full p-8 brutal-shadow">
          <div className="font-mono-mark text-[10px] text-[#5C5C5C]">CIA MARKETING® · ERROR</div>
          <h1 className="font-display text-3xl mt-2">Algo salió mal</h1>
          <p className="font-mono-data text-sm text-[#5C5C5C] mt-3">
            {isExtensionError
              ? "Detectamos que alguna extensión del navegador (Google Translate, Grammarly o un ad-blocker) interfirió con la página. Recargar suele resolverlo."
              : "Ocurrió un error inesperado. Puedes intentar continuar o recargar la página."}
          </p>
          <pre className="bg-[#F4F4F0] border border-[#0A0A0A] mt-4 p-3 text-xs font-mono-data overflow-auto max-h-32" data-testid="error-details">
            {msg}
          </pre>
          <div className="flex gap-2 mt-5">
            <button
              onClick={this.handleRetry}
              className="font-mono-mark text-[10px] bg-white border border-[#0A0A0A] px-4 py-2 hover:bg-[#F4F4F0]"
              data-testid="error-retry"
            >
              REINTENTAR
            </button>
            <button
              onClick={this.handleReload}
              className="font-mono-mark text-[10px] bg-[#E53935] text-white border border-[#E53935] px-4 py-2 hover-brutal"
              data-testid="error-reload"
            >
              RECARGAR PÁGINA
            </button>
          </div>
        </div>
      </div>
    );
  }
}
